import React from "react";

import BinanceImage from "../../../../assets/images/png/binance.png";
import UtivaImage from "../../../../assets/images/svg/logo/utivacolored.svg";
import * as Animate from "react-reveal";

const Logo = ({ image }) => {
  return (
    <div className="">
      <img src={image || UtivaImage} alt="Funders Logo" />
    </div>
  );
};

const SupportSection = () => {
  return (
    <section className="relative pt-16 lg:pt-24 pb-20 md:pb-28 lg:pb-32">
      <div className="relative container mx-auto px-4">
        <Animate.Fade bottom>
          <div className="w-full lg:w-10/12 mx-auto">
            <h3 className="font-semibold text-xl md:text-2xl lg:text-3xl xl:text-4xl text-black text-center font-mono">
              Apply Now
            </h3>
            <p className="mt-3 text-base lg:text-lg text-center">
              1,000 fully funded Scholarship for Africans powered by Binance
              Charity
            </p>
          </div>

          <div className="mx-auto mt-10 lg:mt-16 flex justify-center">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLScnRwKVcDtl1cg6RFHnwmBtfSt_J89TNsK4CBu3p7qCK3ZUow/viewform"
              width="640"
              height="1100"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Binance"
            >
              Loading…
            </iframe>
          </div>

          <div className="mx-auto mt-4 flex flex-col items-center w-6/12 md:-5/12 lg:w-4/12">
            <Logo image={BinanceImage} />
            {/* <Logo image={UtivaImage} /> */}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default SupportSection;
